import { EntityMetadata, HttpResourceUrls } from '@ngrx/data';
import { Appointment } from '../../appointments/state/appointment.model';

export interface PatientAppointmentQueryFilter {
    requestType?: string; // This will tell which type of request needs to be called - remoteappointment, appointment or patient
    personId?: number;
    offset?: number;
    totalLoaded: number;
    batchSize: number;
    lastUpdated: number;
    fromDate: Date;
    toDate: Date;
}

/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const patientAppointmentEntityMetadata: EntityMetadata<Appointment> = {
    entityName: 'PatientAppointment',
    selectId: patientAppointmentSelectId, // .id is used if doing optimistic update
    additionalCollectionState: {
        refreshing: false,
        queryFilter: {
            personId: undefined,
            offset: 0,
            totalLoaded: 0,
            lastUpdated: undefined,
            batchSize: undefined,
            fromDate: new Date(),
            toDate: new Date()
        }
    }
    // https://stackoverflow.com/questions/62828590/how-to-extend-custom-entity-collection-reducers-in-ngrx-data

    // filterFn: nameFilter,
    // sortComparer: sortByName
    // entityDispatcherOptions: { optimisticAdd: true, optimisticUpdate: true }
};

export const patientAppointmentHttpResourceUrls: HttpResourceUrls = {
    entityResourceUrl : '/servlets/ngappointment/entity/', // Not used
    collectionResourceUrl: '/servlets/ngappointments/entities/' // Not used
};

// tslint:disable-next-line:only-arrow-functions typedef
export function patientAppointmentSelectId<T extends { id: any }>(appointment: Appointment) {
    return  appointment === undefined ? undefined : appointment.id || appointment.appointmentId;  // .id is used if doing optimistic update
}
